<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title">
            投诉建议<span style="float:right"><el-button size="mini" type="primary" @click="handleAdd()">新增</el-button></span>
        </div>
        <div class="user_content_blcok_line"></div>
      <div class="user_content_block_show">
        <div class="table-layout" v-if="list.length > 0">
          <el-row>
            <el-col :span="2" class="table-cell-title">ID</el-col>
            <el-col :span="13" class="table-cell-title">内容</el-col>
            <el-col :span="3" class="table-cell-title">日期</el-col>
            <el-col :span="2" class="table-cell-title">状态</el-col>
            <el-col :span="4" class="table-cell-title">操作</el-col>
          </el-row>
          <el-row v-for="(v,k) in list" :key="k">
            <el-col :span="2" class="table-cell">{{v.id}}</el-col>
            <el-col :span="13" class="table-cell">{{v.content}}</el-col>
            <el-col :span="3" class="table-cell">{{v.createtime | formatDateTime}}</el-col>
            <el-col :span="2" class="table-cell">
              <el-tag type="danger" v-if="v.answer == '' ">未回复</el-tag>
              <el-tag v-else type="success">已回复</el-tag>
            </el-col>
            <el-col :span="4" class="table-cell">
              <el-button @click="view_info(v.id,v)" size="mini">查看</el-button>
              <el-button v-if="v.answer == ''" type="primary" @click="edit_info(v.id,v)" size="mini">修改</el-button>
              <el-button v-else size="mini" type="primary" disabled>修改</el-button>
            </el-col>
          </el-row>
        </div>
            
        <div class="home_empty_list" v-else>
          <i class="font iconfont">&#xe600;</i>暂无记录！
        </div>

        <div class="home_fy_block" v-show="list.length > 0" style="margin-top:20px;" >
          <el-pagination v-if="elpagination" @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
        </div>

      </div>

      <el-dialog :visible.sync="dialogVisible" :title="isEdit?'编辑内容':'新增内容'"
        @close="close_dialog" width="30%" :close-on-click-modal="false">
        <div class="home_form_main">
          <el-form :model="info"
            ref="infoForm"
            :rules="rules"
            label-width="150px" size="small">
            <el-form-item label="内容" prop="suggest" :rules="[{required:true,message:'内容不能为空',trigger: 'blur' }]">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="请输入内容"
                  v-model="info.suggest">
                </el-input>
            </el-form-item>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="restForm('info')">取 消</el-button>
          <el-button type="danger" @click="submitForm('info')">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="dialogVisibleviews" title="查看" @close="close_dialog" width="40%" :close-on-click-modal="false">
        <div class="home_form_main">
          <div class="table-layout">
            <el-row>
              <el-col :span="4" class="table-cell-title">ID</el-col>
              <el-col :span="20" class="table-cell">{{info.id}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="table-cell-title">内容</el-col>
              <el-col :span="20" class="table-cell">{{info.content}}</el-col>
            </el-row>
            <el-row v-if="info.answer">
              <el-col :span="4" class="table-cell-title">回复人</el-col>
              <el-col :span="20" class="table-cell">{{info.answer}}</el-col>
            </el-row>
            <el-row v-if="info.answer">
              <el-col :span="4" class="table-cell-title">回复内容</el-col>
              <el-col :span="20" class="table-cell">{{info.response}}</el-col>
            </el-row>
          </div>
        </div>
      </el-dialog>

    </div>
</template>


<script>
import {formatDate} from '@/utils/date';
const defaultInfo = {
  content:null
};
export default {
    inject:['reload'],
    props: {},
    data() {
      return {
          dialogVisible:false,
          dialogVisibleviews:false,
          edit_id:0,
          list:[],
          page_size:10,
          current_page:1,
          total_data:0, // 总条数
          info: Object.assign({}, defaultInfo),
          upload_headers:{},
          isEdit:false
      };
    },
    filters: {
      formatDateTime(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      }
    },
    watch: {},
    computed: {},
    methods: {
        handleAvatarSuccess(res) {
            this.info.imgpath = res.data;
            this.$forceUpdate();
        },
        handleAdd() {
          this.dialogVisible = true;
          this.info = Object.assign({},defaultInfo);
        },
        edit_info(v,info) {
          this.dialogVisible = true;
          this.isEdit = true;
          this.info = info;
        },
        restForm:function(){
            this.dialogVisible = false;
            this.resetForm('info');
        },

        submitForm:function() {
          if(this.isEdit == true){
            this.$post(this.$api.updateSuggest,{id:this.info.id,content:this.info.suggest}).then(res =>{
              if(res.code == 200){
                  this.$message.success(res.message);
                  this.dialogVisible = false;
                  this.getTestList();
                  this.resetForm('info');
                  this.reload();
              }else{
                  this.$message.error(res.message); 
              }
            });
          }else{
            this.info.platId = this.$platId;
            this.info.content = this.info.suggest;
            this.$post(this.$api.createSuggest,this.info).then(res =>{
              if(res.code == 200){
                  this.$message.success(res.message);
                  this.dialogVisible = false;
                  this.getTestList();
                  this.resetForm('info');
                  this.reload();
              }else{
                  this.$message.error(res.message); 
              }
            });
          }
        },

        getTestList:function(){
            this.$get(this.$api.getSuggestList,{pageSize:this.page_size,pageNum:this.current_page,platId:this.$platId}).then(res=>{
                this.list = res.data.list;
                this.page_size = res.data.pageSize;
                this.current_page = res.data.pageNum;
                this.total_data = res.data.total;
            });
        },

        // 分页改变
        current_change:function(e){
            this.current_page = e;
            this.get_user_order();
            this.$scrollTo();
        },

        //添加信息
        get_bug_info:function(){
            this.dialogVisible = true;
        },

        //查看结果
        view_info:function(id,info){
            this.dialogVisibleviews = true;
            this.info = info;
        },

        // 删除处理
        del:function(id){
          this.$confirm('是否要删除本条信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
              let _this = this;
              this.$post(this.$api.deleteTest ,{"params":{id:id}}).then(function(res){
                  if(res.code == 200){
                      _this.getTestList();
                      return _this.$message.success("删除成功");
                  }else{
                      return _this.$message.error(res.message);
                  }
              });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消删除'
            });
            this.getTestList();
          });
        },

        close_dialog:function(){
          this.edit_id = 0;
        }
    },
    created() {
      this.getTestList();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.user_address_list{
    padding-top: 10px;
    ul li{
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #efefef;
        dl{
            float: left;
            display: block;
            width: 650px;
            dt{
                margin-right: 20px;
                font-size: 14px;
                line-height: 30px;
            }
            dd{
                line-height: 20px;
                width: 190px;
                width: 500px;
                float: left;
            }
            dd.address_info{
                color:#999;
                float: left;
                width:100%;
                width: 500px;
            }
        }
        .address_handle{
            color:#666;
            float:right;
            line-height: 40px;
            span{
                margin: 0 10px; 
                i{
                    margin-right: 10px;
                }
                
            }
            span:hover{
                color:#F56C6C;
            }
            span.red{
                color:#F56C6C;
            }
        }
    }

}
    select{
        height: 32px !important;
        line-height: 32px !important;
        padding: 0 !important;
    }
   .home_form_main .el-input, .el-textarea {
        max-width: 250px;
        height: 32px;
        line-height: 32px;
    }
   .home_form_main .el-input--small .el-input__inner {
        max-width: 250px;
        height: 32px;
        line-height: 32px;
        }
.el-cascader {
    display: inherit;
    position: relative;
    font-size: 14px;
    line-height: 32px;
    height: 32px;
    max-width: 250px;
}   

.table-layout {
    margin-top: 20px;
    border-left: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
  }

  .table-cell {
    height: 48px;
    line-height: 48px;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    font-size: 14px;
    color: #606266;
    text-align: center;
    overflow: hidden;
  }
  .table-cell p{
    line-height: 35px;
  }
  .table-cell-title {
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    height: 48px;
    line-height: 48px;
    background: #f5f7fa;
    text-align: center;
    font-size: 14px;
    color: #909399;
  }

 .el-textarea{
    max-width: 250px;
    line-height: 32px; 
    margin-bottom: 20px;
}
</style>